import { render, staticRenderFns } from "./BubbleChart.vue?vue&type=template&id=56a25940&"
import script from "./BubbleChart.vue?vue&type=script&lang=js&"
export * from "./BubbleChart.vue?vue&type=script&lang=js&"
import style0 from "./BubbleChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports